import { render, staticRenderFns } from "./ResetPasswordOnEmail.vue?vue&type=template&id=cc6e14fc&scoped=true"
import script from "./ResetPasswordOnEmail.vue?vue&type=script&lang=js"
export * from "./ResetPasswordOnEmail.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordOnEmail.vue?vue&type=style&index=0&id=cc6e14fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6e14fc",
  null
  
)

export default component.exports